import env from 'configuration'
import { useAgency } from 'context/agency'
import { AuthInit } from 'context/auth'
import { LocationInit } from 'context/location'
import useScript from 'hooks/script'
import { useEffect } from 'react'
import { useRoutes } from 'react-router-dom'
import Routes from 'routing/routes'
import { setGHLSessionKey } from 'utils/auth-helper'
import { applyAgencyTheme } from 'theme/agency-theme'

function App() {
  const routes = useRoutes(Routes())
  const { agency } = useAgency()
  const scriptLoaded = useScript(
    `https://maps.googleapis.com/maps/api/js?key=${env.G_MAP_API_KEY}&loading=async&libraries=places`
  )


  // The agency's white-label colours over the studio tokens (plans/REDESIGN.md).
  useEffect(() => applyAgencyTheme(agency?.location_config), [agency])

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search)
    const sessionkey = queryParams.get('sessionkey')

    if (sessionkey) setGHLSessionKey(sessionkey)
  }, [])

  useEffect(() => {
    const setAppHeight = () => {
      document.documentElement.style.setProperty(
        '--app-height',
        `${window.innerHeight}px`
      )
    }
    window.addEventListener('resize', setAppHeight)
    setAppHeight()
    return () => window.removeEventListener('resize', setAppHeight)
  }, [])

  return (
    <div
      // style={{
      //   backgroundColor: bg_color,
      // }}
      // className='h-screen overflow-y-auto relative'
      // page background: the studio canvas, or the agency's page colour (theme tokens)
      style={{ height: 'var(--app-height)' }}
      className='overflow-y-auto relative bg-canvas'
    >
      <AuthInit>
        <LocationInit>{routes}</LocationInit>
      </AuthInit>
    </div>
  )
}

export default App
